import React, { useState, useEffect } from 'react'
import { post } from '../../lib/api'
import { handleEventLog, handleNotionOrExternalLink, httpToHttps } from '../../lib/utils'
import ChevronRight from '../Images/ChevronRight'
import ChevronLeft from '../Images/ChevronLeft'
import './style.css'

const Carousel = ({ banners, language, isUgcUser }) => {
  const darkChevronColor = window.screen.width < 1100
  const [activeBanner, setActiveBanner] = useState(0)

  function checkImpression(entries) {
    entries.forEach((entry) => {
      if (entry.isVisible) {
        handleEventLog('home', 'impressions', {
          entity_id: entry.target.id,
          entity_type: 'banner',
          module_name: 'banner',
        })
        post('/impressions/pocket_writer_impressions?is_novel=1', {
          data: {
            banner_id: entry.target.id,
            language: language || 'hindi',
          },
        }).catch(err => console.log(err))
      }
    })
  }

  const observer = new IntersectionObserver(checkImpression, {
    delay: 100,
    trackVisibility: true,
    threshold: 0.8,
  })

  function handleMove(num = 0) {
    let i
    const slides = document.getElementsByClassName('mySlides')
    const dots = document.getElementsByClassName('dot')
    for (i = 0; i < slides.length; i += 1) {
      slides[i].style.display = 'none'
    }
    let n = num
    if (n === slides.length) {
      n = 0
      setActiveBanner(0)
    } else if (n === -1) {
      n = slides.length - 1
      setActiveBanner(slides.length - 1)
    } else setActiveBanner(n)

    for (i = 0; i < dots.length; i += 1) {
      dots[i].className = dots[i].className.replace(' active-dot', '')
    }
    slides[n].style.display = 'block'
    dots[n].className += ' active-dot'
  }

  useEffect(() => {
    if (banners.length > 0) {
      banners.forEach((banner) => {
        observer.observe(document.getElementById(banner.banner_id))
      })
    }
    handleMove()
  }, [])

  const handleMoveLeft = () => {
    handleMove(activeBanner - 1)
  }
  const handleMoveRight = () => {
    handleMove(activeBanner + 1)
  }

  const handleBannerClick = (banner) => {
    handleEventLog('home', 'show_clicked', {
      entity_id: banner.banner_id,
      entity_type: 'banner',
      module_name: 'banner',
    })
    if(isUgcUser && banner?.banner_id === 'feb93e1ba9adecce758dd97ad2ee4d8f2a89de32'){
      handleNotionOrExternalLink('https://pocketnovel.notion.site/pocketnovel/Functional-Guide-for-Writers-35838ce4579843f196a99e92ed02c2e1?v=f4fe620088cd4b8cae9e2edfa630753c')
    }else{
      window.location.assign(banner.on_click_url)
    }
  }

  return (
    <div className="slideshow-container">
      <ChevronLeft
        className="arrowLeft"
        height={52}
        width={52}
        onClick={handleMoveLeft}
        fill={darkChevronColor ? null : '#9C9C9C'}
      />
      <ChevronRight
        className="arrowRight"
        height={52}
        width={52}
        onClick={handleMoveRight}
        fill={darkChevronColor ? null : '#9C9C9C'}
      />
      {banners?.map((banner, index) => (
        <div
          className="mySlides fade"
          key={index}
          onClick={() => handleBannerClick(banner)}
        >
          <img
            className="carousel-img"
            src={httpToHttps(banner?.banner_image_url || '')}
            id={banner?.banner_id}
            alt="Banner"
          />
        </div>
      ))}
      <div style={{ 'text-align': 'center' }}>
        {banners?.map((banner, index) => <span key={index} className="dot" />)}
      </div>
    </div>
  )
}

export default Carousel
